import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Unenroll: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        transform="rotate(-90 12 12)"
        fill={color}
      />
      <path
        d="M15.6455 9L8.4481 9C7.63379 9 7.16089 9.92125 7.63556 10.5829L11.3907 15.8174C11.7997 16.3875 12.6533 16.3702 13.0388 15.784L16.4811 10.5494C16.9183 9.8845 16.4414 9 15.6455 9Z"
        fill="white"
      />
    </svg>
  );
};

export default Unenroll;
